import { defineMessage } from 'services/localization';

export const messages = {
    markPopupTitle: defineMessage('mark_po_as_billed'),
    markButtonText: defineMessage('mark_as_billed'),
    markButtonTitle: defineMessage('mark_purchase_order_as_billed'),
    markDescription: defineMessage('please_provide_a_commen__po_is_marked_as_billed'),
    unmarkPopupTitle: defineMessage('unmark_po_as_billed'),
    unmarkButtonText: defineMessage('unmark_as_billed'),
    unmarkButtonTitle: defineMessage('unmark_purchase_order_as_billed'),
    unmarkDescription: defineMessage('please_provide_a_commen_o_is_unmarked_as_billed'),
    markedSuccessToastText: defineMessage('purchase_order_has_been_marked_as_billed'),
    unmarkedSuccessToastText: defineMessage('purchase_order_has_been_unmarked_as_billed'),
    goTo: defineMessage('go_to_displayname'),
};
